import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';

import { VariantOperationsService } from './variant-operations.service';
import { VarientOperationDTO } from './dto/variant-operation.dto';
import { OperationSequenceResponse, OperationSequenceResponseModel, ValAddOperationsModel, VariantNextOpModel, variantOperationResponseModel, VarientIdRequest } from '@gtpl/shared-models/production-management';
import { OperationSequenceRequest } from '../operations-track/dto/operation-sequence.request';
import { OperationTypeEnum, UnitRequest } from '@gtpl/shared-models/common-models';

@Controller('variant-operations')
@ApiTags('variant-operations')

export class VariantOperationsController {
    constructor(
        private variantOperationService: VariantOperationsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

        /**
     * creates or updates a value of Variant Operation
     * @param variantOperationDto variantOperation DTO
     * @returns sequenceResponse
     */
    @Post('/createVariantOperations')
    async createVarientOperation(@Body() operationSeqDto:VarientOperationDTO,isUpdate:boolean=false): Promise<variantOperationResponseModel> {
        try {
         return await this.variantOperationService.createVarientOperation(operationSeqDto,false);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(variantOperationResponseModel, error);
       }
     }

     @Post('/getOperationSequence')
    async getOperationSequence(@Body() inputReq:OperationSequenceRequest):Promise<OperationSequenceResponse> {
        try {
         return await this.variantOperationService.getOperationSequence(inputReq);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(OperationSequenceResponse, error);
       }
     }
     
     @Post('/getOperationsAssignedByVarientId')
    async getOperationsAssignedByVarientId(@Body() inputReq:VarientIdRequest):Promise<OperationSequenceResponseModel> {
      
        try {
         return await this.variantOperationService.getOperationsAssignedByVarientId(inputReq);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(OperationSequenceResponseModel, error);
       }
     }

     @Post('/getNextOperationForVariantId')
    async getNextOperationForVariantId(@Body() inputReq:VariantNextOpModel):Promise<OperationTypeEnum> {
      
        try {
         return await this.variantOperationService.getNextOperationForVariantId(inputReq);
       } catch (error) {
            // return this.applicationExceptionHandler.returnException(OperationTypeEnum, error);
       }
     }

     @Post('/getValAddOperations')
    async getValAddOperations(@Body() unitReq:UnitRequest):Promise<ValAddOperationsModel> {
      
        try {
         return await this.variantOperationService.getValAddOperations(unitReq);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(ValAddOperationsModel, error);
       }
     }

     
}
